module.exports = __webpack_public_path__ + "static/media/rd-memories-2.5e16158b.png";